import { render, staticRenderFns } from "./GameManagement.vue?vue&type=template&id=71297434&scoped=true"
import script from "./GameManagement.vue?vue&type=script&lang=js"
export * from "./GameManagement.vue?vue&type=script&lang=js"
import style0 from "./GameManagement.vue?vue&type=style&index=0&id=71297434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71297434",
  null
  
)

export default component.exports